import React, { Component } from "react";
import '../css/documentation.scss';

export class ViewLocationHelp extends Component {
    render() {
        return (
            <div className="main-content">
                <div className="section__content section__content--p30 createContent">
                    <div className="container-fluid">
                        <h1 style={{ fontSize: '36px', marginTop: '30px' }}>How To View Location Details</h1>
                        <p className="dateFormat" style={{ fontSize: '14px', color: 'grey' }}>18/11/2021 ▪ 2 minutes to read</p>
                        <br /><br />
                        <div class="webMgmt container-fluid">
                            <ol>
                                <li class="createList">
                                    Using the menu on the left, click on "Website Management", then click on the "Locations" link. This will take you to the Locations Listing Page.  <br />
                                    <img src="/img/documentation-img/location/location_navbar.png" class="userImage" />
                                </li>
                                <li class="createList">
                                    In the Locations Listing Page, click on any location of your choice. This will take you to the View Location Details.<br />
                                    <img src="/img/documentation-img/location/location_listing.png" class="userImage" />
                                </li>

                                <li class="createList">
                                    In Location Details Page, you will be able to see the following fields:
                                    <ul class="unorderedList">
                                        <li>
                                            Location Code
                                        </li>
                                        <li>
                                            Location Address
                                        </li>
                                        <li>
                                            Location Name
                                        </li>
                                        <li>
                                            Display Weight
                                        </li>
                                        <li>
                                            Event Format Types
                                        </li>
                                        <li>
                                            Display Start DateTime
                                        </li>
                                        <li>
                                            Display End DateTime
                                        </li>
                                        <li>
                                            Theatre Location Map
                                        </li>
                                        <li>
                                            Details
                                        </li>
                                        <li>
                                            Access Route Details
                                        </li>
                                        <li>
                                            Photos
                                        </li>
                                    </ul>
                                    <div class="alert alert-primary" role="alert">
                                        <i class="fas fa-info-circle" aria-hidden="true"></i>
                                        <strong class="noteHeader">Information:</strong><br/><br/>
                                            - Display weight determines how the item will be displayed. The lower the display weight, the higher it will place on the website.<br />
                                            - Display Start DateTime should always be earlier than Display End DateTime.<br />
                                            - Details and Access Routes Details should be in HTML format.
                                </div>
                            </li>

                                        <li class="createList">
                                            To view the preview image of the locations, click on the “Preview” button, under the “Photos” section.<br />
                                            <img src="/img/documentation-img/location/view_preview_button.png" class="userImage" />
                                        </li>

                                        <li class="createList">
                                            The photo will then be shown. Click on the X on top to cancel preview. <br />
                                            <img src="/img/documentation-img/location/preview_image.png" class="userImage" />
                                        </li>


                            </ol>
                            <div className="text-right">
                                <a href="/documentation/locations/editLocationHelp" className="btn btn-primary">Edit Location &raquo;</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}